// @generated by protoc-gen-es v1.10.0
// @generated from file user/v1/user.proto (package user.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum user.v1.SellerApprovalStatus
 */
export const SellerApprovalStatus = /*@__PURE__*/ proto3.makeEnum(
  "user.v1.SellerApprovalStatus",
  [
    {no: 0, name: "SELLER_APPROVAL_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SELLER_APPROVAL_STATUS_PENDING", localName: "PENDING"},
    {no: 2, name: "SELLER_APPROVAL_STATUS_DENIED", localName: "DENIED"},
    {no: 3, name: "SELLER_APPROVAL_STATUS_APPROVED", localName: "APPROVED"},
  ],
);

/**
 * @generated from enum user.v1.SellerRole
 */
export const SellerRole = /*@__PURE__*/ proto3.makeEnum(
  "user.v1.SellerRole",
  [
    {no: 0, name: "SELLER_ROLE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SELLER_ROLE_MEMBER", localName: "MEMBER"},
    {no: 2, name: "SELLER_ROLE_PARTNER", localName: "PARTNER"},
  ],
);

/**
 * @generated from enum user.v1.SortBy
 */
export const SortBy = /*@__PURE__*/ proto3.makeEnum(
  "user.v1.SortBy",
  [
    {no: 0, name: "SORT_BY_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SORT_BY_FEATURED", localName: "FEATURED"},
  ],
);

/**
 * @generated from message user.v1.CreateUserRequest
 */
export const CreateUserRequest = /*@__PURE__*/ proto3.makeMessageType(
  "user.v1.CreateUserRequest",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message user.v1.CreateUserResponse
 */
export const CreateUserResponse = /*@__PURE__*/ proto3.makeMessageType(
  "user.v1.CreateUserResponse",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message user.v1.GetUserRequest
 */
export const GetUserRequest = /*@__PURE__*/ proto3.makeMessageType(
  "user.v1.GetUserRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message user.v1.GetUserResponse
 */
export const GetUserResponse = /*@__PURE__*/ proto3.makeMessageType(
  "user.v1.GetUserResponse",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message user.v1.UpdateUserRequest
 */
export const UpdateUserRequest = /*@__PURE__*/ proto3.makeMessageType(
  "user.v1.UpdateUserRequest",
  () => [
    { no: 1, name: "user", kind: "message", T: User },
  ],
);

/**
 * @generated from message user.v1.UpdateUserResponse
 */
export const UpdateUserResponse = /*@__PURE__*/ proto3.makeMessageType(
  "user.v1.UpdateUserResponse",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message user.v1.DeleteUserRequest
 */
export const DeleteUserRequest = /*@__PURE__*/ proto3.makeMessageType(
  "user.v1.DeleteUserRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "purge", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message user.v1.DeleteUserResponse
 */
export const DeleteUserResponse = /*@__PURE__*/ proto3.makeMessageType(
  "user.v1.DeleteUserResponse",
  [],
);

/**
 * @generated from message user.v1.ListUsersRequest
 */
export const ListUsersRequest = /*@__PURE__*/ proto3.makeMessageType(
  "user.v1.ListUsersRequest",
  () => [
    { no: 1, name: "filter", kind: "message", T: UserFilter },
  ],
);

/**
 * @generated from message user.v1.ListUsersResponse
 */
export const ListUsersResponse = /*@__PURE__*/ proto3.makeMessageType(
  "user.v1.ListUsersResponse",
  () => [
    { no: 1, name: "users", kind: "message", T: User, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message user.v1.User
 */
export const User = /*@__PURE__*/ proto3.makeMessageType(
  "user.v1.User",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "fullname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "image_src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "shop_logo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "shop_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "shop_tagline", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "seller_approval_status", kind: "enum", T: proto3.getEnumType(SellerApprovalStatus) },
    { no: 9, name: "seller_role", kind: "enum", T: proto3.getEnumType(SellerRole) },
    { no: 10, name: "stripe_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "is_deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "shop_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "cart_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message user.v1.UserFilter
 */
export const UserFilter = /*@__PURE__*/ proto3.makeMessageType(
  "user.v1.UserFilter",
  () => [
    { no: 1, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "sort_by", kind: "enum", T: proto3.getEnumType(SortBy) },
    { no: 4, name: "sort_ascending", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "featured", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "total_results_cap", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

